/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DeveloperRouteImport } from './routes/developer'
import { Route as PublicNoticesRouteImport } from './routes/public-notices'
import { Route as FormsIndexRouteImport } from './routes/forms/index'
import { Route as FormsIdRouteImport } from './routes/forms/$id'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as HomeResourceRouteImport } from './routes/home/$resource'
import { Route as SupportIndexRouteImport } from './routes/support/index'
import { Route as SupportSupportFaqRouteImport } from './routes/support/support-faq'
import { Route as SupportSupportGuideArticleRouteImport } from './routes/support/support-guide-article'
import { Route as SupportSupportGuidesRouteImport } from './routes/support/support-guides'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DeveloperRoute = DeveloperRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicNoticesRoute = PublicNoticesRouteImport.update({
  id: '/public-notices',
  path: '/public-notices',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsIndexRoute = FormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsIdRoute = FormsIdRouteImport.update({
  id: '/forms/$id',
  path: '/forms/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeResourceRoute = HomeResourceRouteImport.update({
  id: '/home/$resource',
  path: '/home/$resource',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportSupportFaqRoute = SupportSupportFaqRouteImport.update({
  id: '/support/support-faq',
  path: '/support/support-faq',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportSupportGuideArticleRoute =
  SupportSupportGuideArticleRouteImport.update({
    id: '/support/support-guide-article',
    path: '/support/support-guide-article',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupportSupportGuidesRoute = SupportSupportGuidesRouteImport.update({
  id: '/support/support-guides',
  path: '/support/support-guides',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/developer': typeof DeveloperRoute
  '/public-notices': typeof PublicNoticesRoute
  '/forms/$id': typeof FormsIdRoute
  '/home/$resource': typeof HomeResourceRoute
  '/support/support-faq': typeof SupportSupportFaqRoute
  '/support/support-guide-article': typeof SupportSupportGuideArticleRoute
  '/support/support-guides': typeof SupportSupportGuidesRoute
  '/forms/': typeof FormsIndexRoute
  '/home/': typeof HomeIndexRoute
  '/support/': typeof SupportIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/developer': typeof DeveloperRoute
  '/public-notices': typeof PublicNoticesRoute
  '/forms/$id': typeof FormsIdRoute
  '/home/$resource': typeof HomeResourceRoute
  '/support/support-faq': typeof SupportSupportFaqRoute
  '/support/support-guide-article': typeof SupportSupportGuideArticleRoute
  '/support/support-guides': typeof SupportSupportGuidesRoute
  '/forms': typeof FormsIndexRoute
  '/home': typeof HomeIndexRoute
  '/support': typeof SupportIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/developer': typeof DeveloperRoute
  '/public-notices': typeof PublicNoticesRoute
  '/forms/$id': typeof FormsIdRoute
  '/home/$resource': typeof HomeResourceRoute
  '/support/support-faq': typeof SupportSupportFaqRoute
  '/support/support-guide-article': typeof SupportSupportGuideArticleRoute
  '/support/support-guides': typeof SupportSupportGuidesRoute
  '/forms/': typeof FormsIndexRoute
  '/home/': typeof HomeIndexRoute
  '/support/': typeof SupportIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/developer'
    | '/public-notices'
    | '/forms/$id'
    | '/home/$resource'
    | '/support/support-faq'
    | '/support/support-guide-article'
    | '/support/support-guides'
    | '/forms/'
    | '/home/'
    | '/support/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/developer'
    | '/public-notices'
    | '/forms/$id'
    | '/home/$resource'
    | '/support/support-faq'
    | '/support/support-guide-article'
    | '/support/support-guides'
    | '/forms'
    | '/home'
    | '/support'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/developer'
    | '/public-notices'
    | '/forms/$id'
    | '/home/$resource'
    | '/support/support-faq'
    | '/support/support-guide-article'
    | '/support/support-guides'
    | '/forms/'
    | '/home/'
    | '/support/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  DeveloperRoute: typeof DeveloperRoute
  PublicNoticesRoute: typeof PublicNoticesRoute
  FormsIdRoute: typeof FormsIdRoute
  HomeResourceRoute: typeof HomeResourceRoute
  SupportSupportFaqRoute: typeof SupportSupportFaqRoute
  SupportSupportGuideArticleRoute: typeof SupportSupportGuideArticleRoute
  SupportSupportGuidesRoute: typeof SupportSupportGuidesRoute
  FormsIndexRoute: typeof FormsIndexRoute
  HomeIndexRoute: typeof HomeIndexRoute
  SupportIndexRoute: typeof SupportIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developer': {
      id: '/developer'
      path: '/developer'
      fullPath: '/developer'
      preLoaderRoute: typeof DeveloperRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public-notices': {
      id: '/public-notices'
      path: '/public-notices'
      fullPath: '/public-notices'
      preLoaderRoute: typeof PublicNoticesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/': {
      id: '/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof FormsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/$id': {
      id: '/forms/$id'
      path: '/forms/$id'
      fullPath: '/forms/$id'
      preLoaderRoute: typeof FormsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/': {
      id: '/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/$resource': {
      id: '/home/$resource'
      path: '/home/$resource'
      fullPath: '/home/$resource'
      preLoaderRoute: typeof HomeResourceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/': {
      id: '/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/support-faq': {
      id: '/support/support-faq'
      path: '/support/support-faq'
      fullPath: '/support/support-faq'
      preLoaderRoute: typeof SupportSupportFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/support-guide-article': {
      id: '/support/support-guide-article'
      path: '/support/support-guide-article'
      fullPath: '/support/support-guide-article'
      preLoaderRoute: typeof SupportSupportGuideArticleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/support-guides': {
      id: '/support/support-guides'
      path: '/support/support-guides'
      fullPath: '/support/support-guides'
      preLoaderRoute: typeof SupportSupportGuidesRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  DeveloperRoute: DeveloperRoute,
  PublicNoticesRoute: PublicNoticesRoute,
  FormsIdRoute: FormsIdRoute,
  HomeResourceRoute: HomeResourceRoute,
  SupportSupportFaqRoute: SupportSupportFaqRoute,
  SupportSupportGuideArticleRoute: SupportSupportGuideArticleRoute,
  SupportSupportGuidesRoute: SupportSupportGuidesRoute,
  FormsIndexRoute: FormsIndexRoute,
  HomeIndexRoute: HomeIndexRoute,
  SupportIndexRoute: SupportIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
